import { AddressDto } from './address.dto';

export class ContactDto {
  firstName: string;
  lastName: string;
  emailAddress?: string;
  phoneNumber?: string;
  address?: AddressDto;
}
